import { createFileRoute } from "@tanstack/react-router";

import { PageTitle } from "@/components/PageTitle";

export const Route = createFileRoute("/$organizationKey/$dossierId/outcome/$questionnaireId")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <PageTitle title="outcome" />
      <div>Hello "/$organizationKey/$dossierId/outcome/$questionnaireId"!</div>
    </>
  );
}
